import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import useDocumentTitle from '../../hooks/useDocumentTitle';
// import ShimmerLoader from '../../hooks/ShimmerLoader';
// import Pagination from "../../hooks/Pagination";
import formatDate from '../../hooks/formatDate';
import { fetchUserCardsForPrint } from "../../store/loyaltySlices/loyaltyPrintSlice";

// import toastr from 'toastr';
import { format } from 'date-fns';

import { QRCodeCanvas } from 'qrcode.react';

export default function LoyaltyUserCardPrint() {
  useDocumentTitle('Print Loyalty Card');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { cards: loyalty_card, loading, error, totalPages } = useSelector((state) => state.loyaltyPrint.userCardPrint);
  const [currentPage, setCurrentPage] = useState(1);

  const location = useLocation();
  // Get everything after the '?'
  const queryParam = location.search.substring(1);
  const cardNumbers = queryParam
    ? queryParam.split(',').filter(Boolean)
    : null;

  const perPage = 25;
  useEffect(() => {
    dispatch(fetchUserCardsForPrint({ perPage, page: currentPage, cardNumbers }));
  }, [currentPage, dispatch]);

  const staffList = [
    "John Smith",
    "John Smith",
  ];
  const isSingle = loyalty_card.length === 1;
  return (
    <div className="flex flex-col md:flex-row gap-4 md:gap-4">
      {error && <div style={{ color: 'red' }}>{error}</div>}

      <div className="w-full  bg-white shadow-lg rounded-2xl p-6">

        <div className="grid grid-flow-col grid-rows-3 gap-4 print:hidden">
          <div className="row-start-1 row-end-4"><h2 className="text-2xl font-bold mb-4">Print Card</h2></div>
          <div className="row-start-1 row-end-4 text-right">
            <button type="button" onClick={() => window.print()} className="py-2 px-4  bg-[#f4a406] text-white py-2 rounded-xl hover:bg-[#d89005] transition-colors">Print</button>
          </div>
        </div>

        <div id="print-area" className="p-4 print:p-0 print:block">
          <div className={`${isSingle ? "flex justify-center" : "grid grid-cols-4 gap-4"
            } print:gap-2`}>
            {loyalty_card.map((item, idx) => (
              <div
                key={idx}
                className="border p-4 flex flex-col items-center justify-between w-full text-center"
              >

                <div>
                  <QRCodeCanvas
                    value={item.card_number}
                    title={item.card_type}
                    size={128}
                    bgColor={"#ffffff"}
                    fgColor={"#000000"}
                    level={"L"}
                    imageSettings={{
                      src: "/ic_launcher.png",
                      x: undefined,
                      y: undefined,
                      height: 20,
                      width: 20,
                      opacity: 1,
                      excavate: true,
                    }}
                  />
                </div>
                <div className="border-t w-full my-2"></div>
                <div>
                  <h2 className="font-semibold text-lg">{item.card_number}</h2>
                  <p className="mt-1">{item.title}. {item.fname} {item.lname}</p>
                  <p className="text-xs text-gray-500 mt-1">Expire On {format(item.deactivation_date, 'dd/MM/yyyy')}</p>
                </div>
              </div>
            ))}
          </div>
        </div>


      </div>
    </div >
  );
}
